<div class="create-dialog-box scrollable-dialog compose-mail">
    <div mat-dialog-title>
        <div class="title d-flex align-items-center justify-content-space-between">
            <h4 class="mb-0">Compose Mail</h4>
            <button class="close-btn bg-transparent p-0 border-none" (click)="close()">
                <i class="flaticon-close"></i>
            </button>
        </div>
    </div>
</div>
<form [formGroup]="compose_email_form" (ngSubmit)="sendMail()" class="form-wrapper">
    <mat-dialog-content>
        <div class="tagus-form-group without-icon">
            <mat-form-field appearance="fill">
                <mat-label>From</mat-label>
                <mat-select name="status" formControlName="from">
                    <mat-option *ngFor="let from_mail of from_mail_list" [value]="from_mail">
                        {{ from_mail }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tagus-form-group mb-20">
            <mat-slide-toggle color="primary" formControlName="agentStatus">Notify
                Agent</mat-slide-toggle>
        </div>
        <div class="d-flex to-mail-wrap mb-5">
            <div role="alert"
                class="alert alert-dark d-flex justify-content-space-between align-items-center to-mail-div"
                *ngFor="let email of to_email_list; let i = index">
                {{ email }}
                <button type="button" (click)="removeToEmail(i)" aria-label="Close"
                    class="close bg-transparent p-0 border-none">
                    <i class="ri-close-line"></i>
                </button>
            </div>
        </div>        

        <div class="tagus-form-group without-icon">
            <mat-form-field appearance="fill">
                <mat-label>To</mat-label>
                <input matInput formControlName="to" (keydown.enter)="addToEmail($event); (false)" />
                <mat-error *ngIf="compose_email_form.get('to').hasError('required')">
                    Required
                </mat-error>
                <mat-error *ngIf="compose_email_form.get('to').hasError('email')">
                    Invalid Email
                </mat-error>
            </mat-form-field>
        </div>

        <!-- <app-role-users 
                (selectedDropdown)="getSelectedDropdown($event)">
            </app-role-users> -->

        <div class="d-flex to-mail-wrap mb-5">
            <div role="alert"
                class="alert alert-dark d-flex justify-content-space-between align-items-center to-mail-div"
                *ngFor="let cc of cc_email_list; let i = index">
                {{ cc }}
                <button type="button" (click)="removeCCEmail(i)" aria-label="Close"
                    class="close bg-transparent p-0 border-none">
                    <i class="ri-close-line"></i>
                </button>
            </div>
        </div>
        <div class="tagus-form-group without-icon">
            <mat-form-field appearance="fill">
                <mat-label>Cc</mat-label>
                <input matInput formControlName="cc" (keydown.enter)="addCCEmail($event); (false)" />
                <mat-error *ngIf="compose_email_form.get('cc').hasError('email')">
                    Invalid Email
                </mat-error>
            </mat-form-field>
        </div>

        <div class="d-flex to-mail-wrap mb-5" *ngIf="true">
            <div role="alert"
                class="alert alert-dark d-flex justify-content-space-between align-items-center to-mail-div"
                *ngFor="let bcc of bcc_email_list; let i = index">
                {{ bcc }}
                <button type="button" (click)="removeBCCEmail(i)" aria-label="Close"
                    class="close bg-transparent p-0 border-none">
                    <i class="ri-close-line"></i>
                </button>
            </div>
        </div>
        <div class="tagus-form-group without-icon" *ngIf="true">
            <mat-form-field appearance="fill">
                <mat-label>Bcc</mat-label>
                <input matInput formControlName="bcc" (keydown.enter)="addBCCEmail($event); (true)" />
                <mat-error *ngIf="compose_email_form.get('bcc').hasError('email')">
                    Invalid Email
                </mat-error>
            </mat-form-field>
        </div>
        <div class="tagus-form-group without-icon">
            <mat-form-field appearance="fill">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" />
            </mat-form-field>
        </div>
        <div class="tagus-form-group mb-20 summernote-container">
            <!-- <div [ngxSummernote]="config" name="html" [innerHTML]="reply_hidden_content"></div> -->
            <app-summernote-editor [initialHtml]="compose_email_form.get('html').value"
                (contentChanged)="contentChanged($event)"></app-summernote-editor>
            <mat-error *ngIf="
                        is_submitted &&
                        compose_email_form.get('html').hasError('required')
                    ">
                Please type something
            </mat-error>
        </div>

        <!-- <div class="mb-10" *ngIf="email_data?.type === 'reply' || email_data?.type === 'forward'">
                <a href="javascript:void" cl><i class="ri-more-fill" (click)="seeOriginalMail()"></i></a>   
            </div> -->

        <!-- <div [innerHTML]="reply_hidden_content" *ngIf="see_original_mail" class="original-mail"></div> -->

        <div class="w-100 d-flex py-2 flex-wrap">
            <div class="alert alert-secondary d-flex justify-content-space-between align-items-center me-5" role="alert"
                *ngFor="let attachment of upload_files; index as i">
                {{ attachment.name | slice: 0:20 }}
                <button type="button" class="close bg-transparent p-0 border-none" data-dismiss="alert"
                    aria-label="Close" (click)="removeDoc(i)">
                    <i class="ri-close-line"></i>
                </button>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="border-t-1 py-4">
        <div class="d-flex gap-x-4 w-100 px-4">
            <div class="w-auto">
                <div class="w-100">
                    <div class="tagus-form-group compose-attach-file">
                        <input type="file" style="display: none" #open_file multiple (change)="selectFiles($event)" />
                        <mat-form-field appearance="fill" (click)="open_file.click()" class="cursor-pointer">
                            <i class="ri-attachment-line"></i>
                            <input readonly matInput placeholder="Choose File" />
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="btn-box w-100 justify-content-end pt-10">
                <button mat-flat-button type="submit" class="tagus">
                    {{
                    email_data?.type === "reply"
                    ? "Reply"
                    : email_data?.type === "forward"
                    ? "Forward"
                    : "Send"
                    }}
                </button>
                <button mat-flat-button type="button" color="warn" (click)="close()">
                    Discard
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</form>